// extracted by mini-css-extract-plugin
export default {"moduleWrapper":"provaDin_moduleWrapper__JGtbT","documentRow":"provaDin_documentRow__xEqRd","documentRow_marmi":"provaDin_documentRow_marmi__txl5Y"};